import { useEffect, useState } from "react";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import Seo from "@/components/Seo";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import KeywordField from "@/components/KeywordField";
import RulerStrip from "@/components/RulerStrip";
import Collection from "@/components/Collection";
import Varsity from "@/components/Varsity";
import Manifesto from "@/components/Manifesto";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] bg-[#050505] flex flex-col items-center justify-center gap-6"
      exit={{ opacity: 0 }}
      transition={{ duration: 0.7, ease: "easeInOut" }}
    >
      <img src="/assets/logo-alpha.png" alt="" className="w-16 object-contain animate-pulse" aria-hidden="true" />
      <p className="text-[10px] uppercase tracking-[0.4em] text-white/45">Loading the Thread</p>
      <div className="flex gap-1.5" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <motion.span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-white/70"
            animate={{ opacity: [0.15, 1, 0.15] }}
            transition={{ repeat: Infinity, duration: 1.1, delay: i * 0.13 }}
          />
        ))}
      </div>
    </motion.div>
  );
}

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => setProducts(res.data.products || []))
      .catch(() => setProducts([]));
  }, []);

  const sets = products.filter((p) => p.category === "set");
  const varsity = products.filter((p) => p.category === "varsity");

  return (
    <main data-testid="home-page">
      <Seo
        title="Always & Forever — Chicago Streetwear by Monica Alexander"
        siteName="Always & Forever"
        description="Embroidered-script hoodie & jogger sets and hand-finished Chicago varsity jackets. Sublimated and airbrushed, priced at real production cost. Shop the drop."
        image="/assets/logo-hero.jpg"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ClothingStore",
          name: "Always & Forever",
          founder: { "@type": "Person", name: "Monica Alexander" },
          description: "Chicago streetwear — sublimated hoodie & jogger sets and airbrushed varsity jackets.",
        }}
      />
      <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
      <Navbar />
      <Hero />
      <KeywordField />
      <Marquee />
      <RulerStrip products={products} />
      <Collection products={sets} />
      <Varsity products={varsity} />
      <Manifesto />
      <Footer />
      <CartDrawer />
    </main>
  );
}
